<app-sales-client-verification-start *ngIf="type === undefined"></app-sales-client-verification-start>
<app-sales-client-verification-status *ngIf="type === 'status'" (nextStepEvent)="onNextStep()"></app-sales-client-verification-status>
